<template>
  <div class="receivables receivables-bill">
    <!-- 账单tab切换 -->
    <div class="receivables-top">
      <div class="switch-menu">
        <el-radio-group
          class="menu-name"
          v-for="(item, index) in menuList"
          :key="index"
          v-model="selectedTab"
          @change="toUrl(item.url)"
        >
          <el-radio-button :label="item.name"></el-radio-button>
        </el-radio-group>
      </div>
      <div class="btn-container">
        <div class="bill-recalculation" @click="billRecalculation">
          <span class="bill-recalculation-img"></span>
          <span>账单重算</span>
        </div>
        <div class="export-excel" @click="openExportMonthBill">
          <span class="export-excel-img"></span>
          <span>导出</span>
        </div>
      </div>
    </div>

    <!-- 列表搜索 -->
    <div class="search">
      <el-form
        ref="searchForm"
        :model="search"
      >
        <div class="search-row">
          <el-form-item label="仓库名称：" prop="warehouseId">
            <el-select
              clearable
              v-model="search.warehouseId"
              placeholder="请选择仓库"
              @change="changeSearchWarehouse"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称：" prop="projectId">
            <el-select
              v-model="search.projectId"
              filterable
              clearable
              placeholder="请选择客户"
              @change="changeProject"
              @clear="clearProjectAndCustomer"
            >
              <el-option
                v-for="item in projectListByWarehouseAndAuth"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期：">
            <el-date-picker
              v-if="search.select === 1"
              v-model="search.date"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
            <el-date-picker
              v-if="search.select === 2"
              v-model="search.month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择日期"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="search-row">
          <el-form-item label="状态：" prop="status">
            <el-select
              clearable
              v-model="search.status"
              placeholder="请选择状态"
            >
              <el-option
                v-for="item in styleList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <div class="btn-operation">
            <el-button icon="el-icon-search" class="btn-blue" @click="searchList">搜索</el-button>
            <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm('searchForm')">重置</el-button>
          </div>
        </div>
      </el-form>
    </div>

    <!-- 账单列表 -->
    <div class="table-main">
      <div class="table">
        <el-table :data="tableData" style="width: 100%" 
        @selection-change="handleSelectionChange"
        :header-cell-class-name="headerCellClassName">
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="creatTime" label="日期"></el-table-column>
          <el-table-column prop="name" label="客户名称"></el-table-column>
          <el-table-column prop="projectName" label="项目名称"></el-table-column>
          <el-table-column prop="statusVal" label="账单状态"></el-table-column>
          <el-table-column prop="amount" label="金额" 
            class-name="cell-right-align-width"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" class="btn-text" @click="lookDetails(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <pagination-tpl
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @queryChange="queryChange"
          ></pagination-tpl>
        </div>
      </div>
    </div>
    
    <div class="batch-vaerify">
      <el-button
        class="btn-white2"
        @click="batchVerify"
      >
        <img class="mod-white" src="~assets/images/product/mod-hign.png">
        批量核实
      </el-button>
    </div>

    <!-- 账单重算 -->
    <el-drawer
      class="bill-recalculation"
      title="账单重算"
      :visible.sync="billRecalculationDrawer"
      :wrapperClosable="false"
      :before-close="handleCloseBillRecalculationDrawer">
      <el-form
        ref="billRecalculationForm"
        :model="billRecalculationForm"
        :rules="billRecalculationFormRules"
      > 
        <el-form-item label="时间类型">
          <el-input v-model="selectedTab" disabled></el-input>
        </el-form-item>
        <el-form-item label="仓库名称" prop="warehouseId">
          <el-select
            clearable
            v-model="billRecalculationForm.warehouseId"
            placeholder="请选择"
            @change="changeWarehouse"
          >
            <el-option
              v-for="item in warehouseList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="projectId">
          <el-select
            v-model="billRecalculationForm.projectId"
            placeholder="请选择"
            filterable
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker
            class="white"
            v-if="search.select === 1"
            v-model="billRecalculationForm.date"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-date-picker
            class="white"
            v-if="search.select === 2"
            v-model="billRecalculationForm.date"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="运费重算" prop="freightRecalculation">
          <el-select
            v-model="billRecalculationForm.freightRecalculation"
            placeholder="请选择"
            disabled
          >
            <el-option
              v-for="item in freightRecalculationList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="telephone">
          <el-input
            v-model="billRecalculationForm.telephone"
            class="white"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button class="btn-gray" @click="handleCloseBillRecalculationDrawer">取消</el-button>
        <el-button class="btn-blue" @click="submit('billRecalculationForm')">确定</el-button>
      </div>
    </el-drawer>
    
    <!-- 详情 -->
    <el-drawer
      class="bill-details-drawer"
      title="详情"
      :wrapperClosable="false"
      :visible.sync="drawer"
      :before-close="handleCloseDrawer">
      <template slot="title">
        <span>详情</span>
        <div class="page-container">
          <div :class="{'pro-page-disabled': prevProjectId === null}">
            <div class="pro-page" :class="{'is-disabled': prevProjectId === null}" @click="pro">
              <img v-if="prevProjectId === null" class="arrow-left" src="~assets/images/arrow/arrow-left-gray.png">
              <img v-else class="arrow-left" src="~assets/images/arrow/arrow-left.png">
              <span>上一页</span>
            </div>
          </div>
          <div :class="{'next-page-disabled': nextProjectId === null}">
            <div class="next-page" :class="{'is-disabled': nextProjectId === null}" @click="next">
              <span>下一页</span>
              <img v-if="nextProjectId === null" class="arrow-right" src="~assets/images/arrow/arrow-right-gray.png">
              <img v-else class="arrow-right" src="~assets/images/arrow/arrow-right.png">
            </div>
          </div>
        </div>
      </template>
      <div class="drawer-content">
        <div class="drawer-content-top">
          <div class="drawer-search">
            <WarehouseProjectSelect
              :parentSelectWarehouseAndProject="parentSelectWarehouseAndProject"
              :parentProjectByWarehouseList="projectByWarehouseList"
              @getSelectWarehouseAndProject="getSelectWarehouseAndProject"
            ></WarehouseProjectSelect>
          </div>
          <div class="drawer-download" @click="openExportMonthBill">
            <img src="~assets/images/home/upload-hign.png">
            导出
          </div>
        </div>

        <!-- 账单基本信息 -->
        <div class="base-info">
          <el-form
            ref="baseInfoForm"
            :model="baseInfoForm"
            label-width="100px"
          >
            <el-form-item label="客户名称" prop="customerName">
              <span class="base-info-content">{{ baseInfoForm.customerName }}</span>
            </el-form-item>
            <el-form-item label="项目名称" prop="projectName">
              <span class="base-info-content">{{ baseInfoForm.projectName }}</span>
            </el-form-item>
            <el-form-item label="账单时间" prop="billTime">
              <span class="base-info-content">{{ baseInfoForm.billTime }}</span>
            </el-form-item>
            <el-form-item label="金额" prop="amount">
              <span class="base-info-content base-info-content-hign">{{ baseInfoForm.amount }}</span>
            </el-form-item>
            <el-form-item label="税率" prop="taxRate">
              <span class="base-info-content">{{ baseInfoForm.taxRate }}</span>
            </el-form-item>
            <el-form-item label="含税金额" prop="taxes">
              <span class="base-info-content base-info-content-hign">{{ baseInfoForm.taxes }}</span>
            </el-form-item>
            <el-form-item label="账单状态" prop="statusVal">
              <span 
                :class="[
                  'base-info-status',
                  {
                    'green-base-info-status': (baseInfoForm.status == 2 || baseInfoForm.status == 4)
                  },
                ]"
              >
                <span 
                  v-if="baseInfoForm.statusVal" 
                  :class="[
                    {
                      'circle': (baseInfoForm.status == 1 || baseInfoForm.status == 3),
                      'green-circle': (baseInfoForm.status == 2 || baseInfoForm.status == 4)
                    },
                  ]"
                >
                </span>
                {{ baseInfoForm.statusVal }}
              </span>
            </el-form-item>
            <el-form-item prop="fileList">
              <div slot="label">
                上传附件
                <el-tooltip effect="dark" content="最多上传6个，支持Excel或者word" placement="top">
                  <img class="mark" src="~assets/images/help/help-hign.png">
                </el-tooltip>
              </div>
              <div class="show-file-list">
                <div class="show-file-name" v-for="(item, index) in fileList" :key="index">
                  <el-tooltip effect="dark" :content="item.name" placement="top-start">
                    <div>
                      <span class="download-name" @click="download(item)">{{ item.name }}</span>
                      <img class="close" src="~assets/images/close.png" @click="onRemoveFileList(index)">
                    </div>
                  </el-tooltip>
                </div>
              </div>
              <el-upload
                v-if="baseInfoForm.status === 1?true:false"
                class="upload-demo"
                :class="{active: !isUploadText }"
                action="#"
                :limit="6"
                :disabled="baseInfoForm.status > 1?true:false"
                :show-file-list="false"
                :multiple="false"
                :auto-upload="true"
                :on-exceed="handleExceed"
                :before-upload="beforeUpload"
                :file-list="fileList">
                <img class="upload-hign" src="~assets/images/home/upload-hign.png">
                <span class="upload-text">上传文件</span>
              </el-upload>
            </el-form-item>
            <el-form-item label="项目备注" prop="projectRemark">
              <span class="base-info-content">{{ baseInfoForm.projectRemark }}</span>
            </el-form-item>
          </el-form>
        </div>

        <!-- 费用明细 -->
        <div class="expense-info">
          <p class="expense-info-title">费用明细</p>
          <el-collapse accordion>
            <el-collapse-item
              v-for="(item, index) in list"
              :key="index"
            >
              <template slot="title">
                <img class="arrow-right" src="~assets/images/arrow/arrow-right.png">
                <span>{{ item.feetypeVal }}</span>
                <div class="amount-info">
                  <span class="amount-text">（金额：{{ item.totalAmount }}</span>
                  <span>含税金额：{{ item.totalTaxIncludedAmount }}）</span>
                </div>
              </template>
              <div class="table">
                <el-table
                  :data="item.tableData"
                  style="width: 100%"
                  show-summary
                  :summary-method="getSummaries"
                  :header-cell-class-name="headerExpenseInfoCellClassName"
                >
                  <el-table-column label="明细" prop="detailed">
                    <template slot-scope="scope">
                      <p :class="{ active: scope.row.detailed === '调整项' }">
                        {{ scope.row.detailed }}
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column label="数据" prop="data" class-name="cell-right-align-width"></el-table-column>
                  <el-table-column label="金额" prop="oldAmount" class-name="cell-right-align-width">
                    <template slot-scope="scope">
                      <p>{{ scope.row.oldAmountCopy }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column v-if="item.feetype == 5" label="" class-name="cell-right-align-width"></el-table-column>
                  <el-table-column v-else label="含税金额" prop="oldTaxIncludedAmount" class-name="cell-right-align-width">
                    <template slot-scope="scope">
                      <p>{{ scope.row.oldTaxIncludedAmountCopy }}</p>
                    </template>
                  </el-table-column>
                  <el-table-column label="备注" align="center">
                    <template slot-scope="scope">
                      <img
                        v-if="scope.row.detailed !== '调整项'" 
                        class="edit"
                        src="~assets/images/edit/edit.png"
                        @click="openModRemarks(scope.row)"
                      >
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        v-if="baseInfoForm.status > 1?false:scope.row.detailed !== '调整项'"
                        class="btn-text"
                        type="text"
                        @click="adjustment(scope.row.id, item.feetype)"
                        >调整</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>

        <!-- 调整记录 -->
        <div class="adjustment-record">
          <p class="adjustment-record-title">调整记录</p>
          <div class="table records-table">
            <el-table :data="recordsData" :header-cell-class-name="headerRecordsCellClassName">
              <el-table-column
                v-for="(item, index) in recordsTitleList"
                :key="index"
                :label="item.label"
                :prop="item.prop"
                :width="item.width"
                :class-name="item.alignment === 'right'?`cell-right-align-width`:''"
                show-overflow-tooltip
              >
                <template slot="header">
                  <div v-if="item.prop === 'time'">
                    <span>{{ item.label }}</span>
                    <span class="brushing" @click="sortFnc(1)"></span>
                  </div>
                  <div v-if="item.prop === 'accountName'">
                    <span>{{ item.label }}</span>
                    <span class="brushing" @click="sortFnc(2)"></span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer">
              <pagination-tpl
                :total="recordsTotal"
                :currentPage="recordsCurrentPage"
                :pageSize="recordsPageSize"
                @queryChange="recordsQueryChange"
              ></pagination-tpl>
            </div>
          </div>
        </div>
      </div>
      <div class="drawer-footer" v-if="baseInfoForm.status == 1">
        <el-button
          class="btn-blue"
          @click="batchVerification"
        >核实</el-button>
      </div>
    </el-drawer>

    <!-- 调整 -->
    <el-dialog
      title="调整"
      top="22vh"
      :visible.sync="dialog"
      width="430px"
    >
      <el-form ref="billForm" :model="billForm">
        <el-form-item label="金额（元）" prop="amount">
          <el-input
            v-model="billForm.amount"
            class="white"
            placeholder="请输入金额"
            @input="inputUnitPrice(billForm.amount)"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remarks">
          <el-input
            type="textarea"
            v-model="billForm.remarks"
            class="white"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-gray" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 修改备注 -->
    <el-dialog
      title="备注"
      top="22vh"
      :visible.sync="modifyRemarksDialog"
      width="430px"
      class="mod-remark"
    >
      <el-form ref="modifyRemarksForm" :model="modifyRemarksForm">
        <el-form-item prop="remarks">
          <el-input
            type="textarea"
            v-model="modifyRemarksForm.remarks"
            class="white"
            :disabled="baseInfoForm.status > 1?true:false"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-gray" @click="closeModifyRemarksDialog">取消</el-button>
        <el-button class="btn-blue" @click="modifyRemarks">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 导出 -->
    <el-dialog
      title="导出"
      top="22vh"
      :visible.sync="exportDialog"
      width="430px"
      class="month-export-radio"
    >
      <el-radio-group v-model="monthExportRadio">
        <el-radio v-for="(item, index) in monthExportTypeList" :key="index" :label="item.id">{{ item.name }}</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-gray" @click="closeExportDialog">取消</el-button>
        <el-button :disabled="loading" class="btn-blue" :class="{'btn-loading':loading}" @click="confirmExport">{{ loading ? '导出中':'确定'}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import customerBillMixins from '@/common/mixins/customer-bill.js'
export default {
  mixins: [customerBillMixins],

  data() {
    return {
      selectedTab: '月账单',
      search: {
        select: 2,
        date: "",
        month: "",
        customer: "",
        projectId: "",
        warehouseId: "",
        status: ""
      },
      loading: false
    }
  },

  activated() {
    this.selectedTab = '月账单'
    this.search.select = 2
  },

  created() {
    this.initFinancicalReconciliationList();
  },

  methods: {
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/finance/receivables.scss';
</style>